import { render, staticRenderFns } from "./Smallprogram.vue?vue&type=template&id=4b1f4622&scoped=true&"
import script from "./Smallprogram.vue?vue&type=script&lang=js&"
export * from "./Smallprogram.vue?vue&type=script&lang=js&"
import style0 from "./Smallprogram.vue?vue&type=style&index=0&id=4b1f4622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1f4622",
  null
  
)

export default component.exports